import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoIcon from '@mui/icons-material/Info';
import SettingsIcon from '@mui/icons-material/Settings';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CodeIcon from '@mui/icons-material/Code';
import { ContactUsModal } from './modals/ContactUsModal';
import { AboutModal } from './modals/AboutModal';
import { SettingsModal } from './modals/SettingsModal';
import { AiModal } from './modals/AiModal';
import { useNavigate, useLocation } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    paddingLeft: '16px',
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  iconButton: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
  },
  askAiButton: {
    backgroundColor: theme.palette.type === 'dark' ? '#ffffff' : '#000000',
    color: theme.palette.type === 'dark' ? '#000000' : '#ffffff',
    borderRadius: '8px',
    padding: '8px 16px',
    textTransform: 'none',
    fontWeight: 600,
    position: 'relative',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#e5e7eb' : '#1a1a1a',
    },
  },
  devHubButton: {
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
    padding: '7px 14px',
    textTransform: 'none',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    marginRight: 4,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  devHubButtonActive: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(96,165,250,0.15)' : '#eff6ff',
    color: theme.palette.type === 'dark' ? '#93c5fd' : '#2563eb',
    border: '1px solid #2563eb',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(96,165,250,0.22)' : '#dbeafe',
    },
  },
  betaBadge: {
    position: 'absolute',
    top: '-3px',
    right: '-6px',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    fontSize: '10px',
    fontWeight: 700,
    padding: '2px 5px',
    borderRadius: '4px',
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const HeaderActions: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [contactOpen, setContactOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const isDevHubActive = location.pathname.startsWith('/marketplace/dev-hub');

  return (
    <>
      <Box className={classes.leftSection}>
        <Button
          className={`${classes.devHubButton} ${isDevHubActive ? classes.devHubButtonActive : ''}`}
          startIcon={<CodeIcon style={{ fontSize: '18px' }} />}
          onClick={() => navigate('/marketplace/dev-hub')}
        >
          Dev Hub
        </Button>
        <Button
          className={classes.askAiButton}
          startIcon={<AutoAwesomeIcon style={{ fontSize: '20px' }} />}
          onClick={() => setAiModalOpen(true)}
        >
          Ask AI
          <span className={classes.betaBadge}>BETA</span>
        </Button>
      </Box>
      <Box className={classes.rightSection}>
        <Tooltip title="Contact Us" arrow>
          <IconButton
            className={classes.iconButton}
            onClick={() => setContactOpen(true)}
          >
            <HelpOutlineIcon style={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="About" arrow>
          <IconButton
            className={classes.iconButton}
            onClick={() => setAboutOpen(true)}
          >
            <InfoIcon style={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Settings" arrow>
          <IconButton
            className={classes.iconButton}
            onClick={() => setSettingsOpen(true)}
          >
            <SettingsIcon style={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
      </Box>

      <AiModal open={aiModalOpen} onClose={() => setAiModalOpen(false)} />
      <ContactUsModal
        open={contactOpen}
        onClose={() => setContactOpen(false)}
      />
      <AboutModal open={aboutOpen} onClose={() => setAboutOpen(false)} />
      <SettingsModal
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
      />
    </>
  );
};
